import {schema} from 'modules/common/components/Form'

export default schema.object({
  name: schema
    .string()
    .trim()
    .required('Please enter your name.'),
  pin: schema
    .string()
    .required('Please enter a valid pin.')
    .min(6, 'Please enter at least 6 character pin.'),
})
